import type { ErrorIntlMessage } from './types';

export const isErrorIntlMessage = (object: any): object is ErrorIntlMessage => typeof object?.id === 'string';
